import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenu,
  Typography,
  Button,
} from '@ui/components';
import { ArrowSmallDown } from '@ui/components/icons';
import { languages } from '@shared/global/i18n';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { FC } from 'react';

export const LanguagePicker: FC = () => {
  const { setUserLanguage } = useCurrentUser();
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost">
          <img
            src={`${import.meta.env.VITE_BASE_PATH}/locales/${currentLanguage}/flag.svg`}
            className="size-4 rounded-full object-none border-1 border-surface-hover"
            alt={currentLanguage}
          />
          <Typography variant="labelSmallBold" className="text-weak">
            {currentLanguage.toLocaleUpperCase()}
          </Typography>
          <ArrowSmallDown />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="max-h-96 min-w-25 overflow-auto">
        {languages
          .filter((lang) => lang !== currentLanguage)
          .map((language) => (
            <DropdownMenuItem onClick={() => setUserLanguage(language)} key={language}>
              <img
                className="size-4 rounded-full object-none border-1 border-surface-hover"
                src={`${import.meta.env.VITE_BASE_PATH}/locales/${language}/flag.svg`}
                alt={currentLanguage}
              />
              <Typography variant="labelSmallBold" className="text-weak">
                {language.toLocaleUpperCase()}
              </Typography>
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
